import {LocalDateTime} from 'js-joda'
import {Decoder, field, nullable, number, object, string} from 'json-bouncer'
import {localDateTimeDecoder} from '../Data/DecodeHelper'
import * as PrismaFileType from './PrismaFileType'

export interface M {
    readonly id: number
    readonly prismaRequestId: number
    readonly bpsUserId: number | null
    readonly cis2UserId: number | null
    readonly type: PrismaFileType.M
    readonly filename: string
    readonly created: LocalDateTime
}

export function decoder(): Decoder<M> {
    return object({
        id: field('id', number()),
        prismaRequestId: field('prismaRequestId', number()),
        bpsUserId: field('bpsUserId', nullable(number())),
        cis2UserId: field('cis2UserId', nullable(number())),
        type: field('type', PrismaFileType.decoder()),
        filename: field('filename', string()),
        created: field('created', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaFile.ts